import { Button, Modal } from '@sailadv/hdata-ui';
import { useTranslation } from 'react-i18next';

import { createModalHook } from '../../lib/create-modal-hook.helper';
import * as Styled from './common-modal.styles';
import { CommonModalProps } from './common-modal.types';

export const CommonModalComponent = ({
	title,
	description,
	okText,
	cancelText = 'Cancel',
	onClose,
	onConfirm,
	children,
	content,
	isLoading,
	disabled,
	allowClose = true,
	overflowVisible = false,
}: CommonModalProps) => {
	const { t } = useTranslation('common');

	const ModalComponent = overflowVisible ? Styled.OverflowVisibleModal : Modal;

	return (
		<ModalComponent
			open
			title={title}
			description={description}
			onClose={onClose}
			{...(content && { tone: 'warning' })}
			alignment={children ? 'left' : 'center'}
			dismissible={allowClose && !isLoading}
			footer={
				<>
					{allowClose && (
						<Button variant="secondary" size="md" onClick={onClose} disabled={isLoading}>
							{cancelText || t('modal.button.cancel')}
						</Button>
					)}
					<Button variant="primary" size="md" onClick={onConfirm ?? onClose} loading={isLoading} disabled={disabled}>
						{okText || t('modal.button.ok')}
					</Button>
				</>
			}
		>
			{children || content}
		</ModalComponent>
	);
};

export default createModalHook<CommonModalProps>((props) => () => <CommonModalComponent {...props} />, {
	variant: 'standalone',
});
